import type { ToolbarDesignTokens } from '@primeuix/themes/types/toolbar';

 export default {
    root: {
        gap: "1rem",
        color: "{content.color}",
        padding: "0px",
        background: "{content.background}",
        borderColor: "{content.border.color}",
        borderRadius: "{content.border.radius}"
    }
} satisfies ToolbarDesignTokens;